module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921111149_T.bd4dd235.jpg";